export default {
  namespaced: true,
  state: () => ({
    units: [],
    loading: false,
    error: null,
  }),
  getters: {
    allUnits: state => state.units,
    unitCount: state => state.units.length,
    activeUnits: state => state.units.filter(u => u.status === 'active'),
    inactiveUnits: state => state.units.filter(u => u.status === 'inactive'),
  },
  mutations: {
    setUnits(state, units) { state.units = units; },
    addUnit(state, unit) { state.units.push(unit); },
    updateUnit(state, updatedUnit) {
      const index = state.units.findIndex(u => u.id === updatedUnit.id);
      if(index !== -1) state.units.splice(index, 1, updatedUnit);
    },
    removeUnit(state, id) { state.units = state.units.filter(u => u.id !== id); },
    setLoading(state, loading) { state.loading = loading; },
    setError(state, error) { state.error = error; },
  },
  actions: {
    async fetchUnits({ commit }) {
      commit('setLoading', true);
      try {
        const data = await new Promise(resolve =>
          setTimeout(() => resolve([
            { id: 1, name: 'Unit A', status: 'active' },
            { id: 2, name: 'Unit B', status: 'inactive' },
          ]), 500)
        );
        commit('setUnits', data);
      } catch (err) { commit('setError', err.message); }
      finally { commit('setLoading', false); }
    },
    async createUnit({ commit }, unit) {
      commit('setLoading', true);
      try {
        const newUnit = { ...unit, id: Date.now() };
        await new Promise(resolve => setTimeout(resolve, 300));
        commit('addUnit', newUnit);
      } catch (err) { commit('setError', err.message); }
      finally { commit('setLoading', false); }
    },
    async updateUnitData({ commit }, unit) {
      commit('setLoading', true);
      try {
        await new Promise(resolve => setTimeout(resolve, 300));
        commit('updateUnit', unit);
      } catch (err) { commit('setError', err.message); }
      finally { commit('setLoading', false); }
    },
    async deleteUnit({ commit }, id) {
      commit('setLoading', true);
      try {
        await new Promise(resolve => setTimeout(resolve, 300));
        commit('removeUnit', id);
      } catch (err) { commit('setError', err.message); }
      finally { commit('setLoading', false); }
    },
    toggleUnitStatus({ commit, state }, id) {
      const unit = state.units.find(u => u.id === id);
      if(unit) commit('updateUnit', { ...unit, status: unit.status === 'active' ? 'inactive' : 'active' });
    }
  },
};
